<template>
	<div class="meeting-calendar">
		<div class="search">
			<van-search placeholder="请输入会议名称或关键词查询会议" v-model="searchKeyWord" @search="onSearch"/>
		</div>
		<van-tabs v-model="active" animated title-active-color="#090909" title-inactive-color="#999" color="#901d22" sticky>
		  <van-tab  title="时间">
		  	   <calendar ref="calendar" @changeMonth="getMonthMeetings" @changeDay="dateInRange"></calendar>
		  	   <div class="meetingContainer">
		  	   		<div class="meetingList" v-if="dayMeetings.length>0">
		  	   			<h3><span></span>当日会议</h3>
		  	   			<div class="meetingList">
			  	   				<template v-for="(item,index) in dayMeetings" >
			  	   						<item-block :itemContent="item" :key="index"></item-block>					
			  	   				</template>
		  	   			</div>
		  	   		</div>
		  	   		<div class="meetingList" v-if="monthMeetings.length>0">
		  	   			<h3><span></span>本月会议</h3>
		  	   			<div class="meetingList">
		  	   					<template v-for="(item,index) in monthMeetings">
		  	   						<item-block :itemContent="item" :key="index"></item-block>		  	  			
		  	   					</template>
		  	   			</div>
		  	   		</div>
		  	   </div>
		  </van-tab>
		  <van-tab  title="地区">
		  		<region :historyWords="historyWords" @clearHistory="clearHistory" @goSearch="onSearch"></region>
		  </van-tab>
		</van-tabs>
	</div>
</template>
<script>
	import Calendar from '../../components/Meeting/Calendar'
	import Region from '../../components/Meeting/Region'
	import ItemBlock from '../../components/ItemBlock'
	import {MeetingMonth} from '../../config/interface.js'
	export default{
		components:{
			Calendar,
			Region,
			ItemBlock
		},
		data(){
			return{
				count:0,
				active:0,
				searchKeyWord:'',
				monthMeetings:[],  //本月会议
				monthMeetings2:[], //本月会议(未做处理的数据)
				dayMeetings:[],    //今日会议
				historyWords:[],      //历史搜索
				currentYear:new Date().getFullYear(),
				currentMonth:new Date().getMonth()+1,
				currentDay:new Date().getDate()
			}
		},
		watch:{
			active(newValue,oldValue){
				this.count<=0?this.count++:'';
				newValue==0&&this.count==1?this.getMonthMeetings(this.currentMonth,this.currentYear):'';
			}
		},
		mounted(){
			this.active=this.$route.params.active?this.$route.params.active:0;
			this.active==0?this.getMonthMeetings(this.currentMonth):'';
			this.currentMonth=this.currentMonth<10?'0'+this.currentMonth:this.currentMonth;
			this.currentDay=this.currentDay<10?'0'+this.currentDay:this.currentDay;
			// this.getMonthMeetings(this.currentMonth);
			this.getHistoryWords();
		},
		methods:{
			//搜索事件
			onSearch(obj){
				if(obj.name){
					this.searchKeyWord=obj.name;
				}
				this.searchKeyWord=(this.searchKeyWord).replace(/(^\s*)|(\s*$)/g, '');
				if(this.searchKeyWord==''){
					common.Toast('请输入搜索内容','',1000)
				}else{
					if(obj.name){
						common.setLocalStorage('meetingsHistory',{name:obj.name,id:obj.id},0)
					}
					this.$router.push({
						path:'/meeting/search',
						query:{
							searchKeyWord:this.searchKeyWord,
							id:obj.id
						}
					})
				}
			},
			//当月会议
			getMonthMeetings(month,year){
				this.$store.dispatch('isShowLoading',true);
				const url=MeetingMonth;
				const method='POST'
				let params={
					month:month,
					year:year
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data1=JSON.parse(JSON.stringify(res.data));
						let data2=JSON.parse(JSON.stringify(res.data));
						data1.forEach((item,index)=>{
							item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.end_at.split(' ')[0]).split('-');
							item.end_at=end_at_arr[1]+'.'+end_at_arr[2];

						})
						this.monthMeetings=data1;
						data2.forEach((item,index)=>{
							item.start_at=item.start_at.split(' ')[0];
							item.end_at=item.end_at.split(' ')[0];
						})
						this.monthMeetings2=data2;
						this.$refs.calendar.init(data2);
						this.dateInRange(this.currentYear+'-'+this.currentMonth+'-'+this.currentDay);

					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			//今日会议
			getDayMeetings(data){
				data.start_at=((data.start_at.split(' ')[0]).split('-')).join('.');
				let end_at_arr=(data.end_at.split(' ')[0]).split('-');
				data.end_at=end_at_arr[1]+'.'+end_at_arr[2];
				this.dayMeetings=data;
			},
			//判断一个日期是否在时间范围内
			dateInRange(day){
				this.dayMeetings=[];
				let timeStamp=new Date(day).getTime();
				let data=JSON.parse(JSON.stringify(this.monthMeetings2));    //深拷贝
				data.forEach((value,index)=>{
					let startTime=value.start_at;
					let endTime=value.end_at;
					if(timeStamp>=new Date(startTime).getTime()&&timeStamp<=new Date(endTime).getTime()){
						value.start_at=((value.start_at.split(' ')[0]).split('-')).join('.');
						let end_at_arr=(value.end_at.split(' ')[0]).split('-');
						value.end_at=end_at_arr[1]+'.'+end_at_arr[2];
						this.dayMeetings.push(value)
					}
				})
			
			},
			//获取本地存储的关键词
			getHistoryWords(){
				let historyWords=common.getLocalStorage('meetingsHistory');
				if(historyWords){
					this.historyWords=JSON.parse(historyWords);
				}else{
					this.historyWords=[];
				}
			},
			//清除搜索历史
			clearHistory(){
				common.clearLocalStorage('meetingsHistory');
				this.getHistoryWords();
			}

			
		}
		
	}
</script>
<style lang="scss">
	.meeting-calendar{
		.search{
			.van-search__content{
				border:1px solid #d3d3d3;
				background:#fff;
			}
			.van-icon{
				color:#999;
				font-size:22px;
				margin-right:5px;
			} 
			::-webkit-input-placeholder { 
				font-size:13px;
			    color:$color-gray;
			}
		}
		.van-tabs--line .van-tabs__wrap{
			border-bottom:1px solid #979797;
		}
		.meetingContainer{
			background:#f1f2f4;
			.meetingList{
				h3{
					padding-left:5px;
					font-size: 15px;
					color:$color-black;
					background:#fff;
					line-height:35px;
					span{
						display: inline-block;
						vertical-align:-2px;
						height:14px;
						border-left:2px solid $color-main;
						margin-right:5px;
					}
				}
				.meetingList{
					padding:0 12px;
					background:#fff;
					/*.item-block:last-child{
						border:0px;
					}*/
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Meeting/calendar.vue